const {
  VITE_STAGE: STAGE,
  VITE_APP_CLERK_PUBLIC_KEY: CLERK_PUBLIC_KEY,
  VITE_APP_API_URL: API_URL
} = import.meta.env;

export { STAGE, CLERK_PUBLIC_KEY, API_URL };
